<template>
  <div class="flex justify-between items-center ml-20 mt-4 flex-wrap">
    <div
      class="flex items-center text-sm gap-1 font-normal"
      :class="{ 'text-EXPONDO-secondary': isSecondaryColor }"
    >
      <span class="iconify fa-pro-light--shield-check shrink-0" />
      <button
        :class="!readOnly ? 'underline cursor-pointer' : 'cursor-default'"
        data-testid="guaranteeTitle"
        @click="!readOnly ? $emit('click') : null"
      >
        {{ title }}
      </button>
    </div>
    <ProductPricing
      v-if="extraGuaranteePrice !== null"
      :full-product-price="extraGuaranteePrice"
      :is-vertical-price="true"
      :is-price-centered="false"
      :size="PRODUCT_PRICING_SIZE.SMALL"
      :thin-font="true"
    />
  </div>
</template>

<script lang="ts">

import { PRODUCT_PRICING_SIZE } from '~~/constants/productCardPricing';

export default defineComponent({
  name: 'ExtraGuaranteeProductCard',

  props: {
    title: {
      type: String,
      required: true,
    },
    extraGuaranteePrice: {
      type: Number,
      default: null,
    },
    isSecondaryColor: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup() {

    return { PRODUCT_PRICING_SIZE };

  },
});

</script>
